import Image from "next/image";
import Link from "next/link";

const data = [
  {
    title:
      "PERSEPSI MASYARAKAT ATAS KEBIJAKAN PEMENSIUNAN DINI PLTU BATU BARA DALAM TRANSISI ENERGI",
    image:
      "/images/publications/Persepsi Masyarakat atas Kebijakan Pemensiunan Dini PLTU Batu Bara dalam Transisi Energi_Cerah-Poldev (4)-1_page-0001.jpg",
    file: "https://drive.google.com/file/d/1bx4GYkC0WTerSsDaz3ClSKFGODGp-0sX/view?usp=drive_link",
  },
  {
    title: "Keterjangkauan Harga Perumahan di Indonesia",
    image: "/images/publications/id_survei_properti-1_pages-to-jpg-0001.jpg",
    file: "https://drive.google.com/file/d/1cpviYH22Z6Gwnrgd3YaoFjBPTS4_Dl11/view?usp=drive_link",
  },
  {
    title: "Menuju Transisi Energi: Pesan Rakyat Untuk Presiden Masa Depan",
    image:
      "/images/publications/id_menuju_transisi_energi_pesan_rakyat_untuk_presiden_masa_depan-1_pages-to-jpg-0001.jpg",
    file: "https://drive.google.com/file/d/1jXte4qW5RjCNmerWi3wroOiU_26WYOWx/view?usp=drive_link",
  },
  {
    title:
      "SURVEI NASIONAL OPINI PUBLIK TERKAIT JUST ENERGY TRANSITION PARTNERSHIP (JETP)",
    image:
      "/images/publications/id_survei_nasional_opini_publik_terkait_just_energy_transition_partnership-1_page-0001.jpg",
    file: "https://drive.google.com/file/d/1Xfi0XGG8hu-QoAtKM2Prg4vsh6VAZ16O/view?usp=drive_link",
  },
  {
    title: "National Public Opinion Survey on the Just Energy Transition Partnership (JETP) — English version",
    image: null,
    file: "https://drive.google.com/file/d/1xvLWWe3PrMAMb1qsrLdK-h0FRvxJOLhP/view?usp=drive_link",
  },
];

export default function HomePub() {
  return (
    <div className="p-10 lg:px-0">
      <div className="lg:min-h-140 h-full lg:bg-[url('/images/logo-unitrend.png')] bg-no-repeat bg-center bg-cover">
        <div className="pt-10 lg:pt-24">
          <h2 className="text-2xl text-gray-500 text-center">Publikasi Kami</h2>
        </div>

        <ul className="mx-auto mt-10 grid w-full max-w-6xl grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {data.map((pub) => (
            <li key={pub.file} className="overflow-hidden rounded-md bg-white shadow-md">
              <Link
                href={pub.file}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-full flex-col"
              >
                <div className="relative flex aspect-[3/4] items-center justify-center bg-slate-100">
                  {pub.image ? (
                    <Image
                      src={pub.image}
                      fill
                      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 20vw"
                      className="object-contain"
                      alt={`Sampul ${pub.title}`}
                    />
                  ) : (
                    <div className="flex h-full w-full flex-col justify-center bg-brandblue px-5 text-center text-white">
                      <span className="mb-4 text-sm uppercase tracking-widest">Unitrend</span>
                      <span className="text-lg font-semibold">JETP</span>
                      <span className="mt-3 text-sm">English version</span>
                    </div>
                  )}
                </div>
                <div className="flex flex-1 flex-col justify-between p-4">
                  <h3 className="text-sm font-medium leading-snug text-slate-800">{pub.title}</h3>
                  <span className="mt-4 text-sm font-semibold text-brandblue">Lihat publikasi →</span>
                </div>
              </Link>
            </li>
          ))}
        </ul>

        <p className=" max-w-5xl mx-auto text-sm font-light bg-white my-10 text-justify text-slate-700">
          Unitrend telah melakukan berbagai riset yang mendalam di bidang
          transisi energi dan politik di Indonesia. Publikasi komprehensif kami
          mencakup analisis mendetail mengenai perubahan kebijakan energi,
          dampak sosial-ekonomi, serta dinamika politik yang memengaruhi sektor
          energi. Dengan fokus pada isu-isu kritis dan solusi praktis, riset
          kami memberikan wawasan yang berharga bagi para pengambil keputusan
          dan peneliti di bidang ini. Unitrend berkomitmen untuk menjadi sumber
          terpercaya dalam memahami dan mengarahkan transisi energi di
          Indonesia.
        </p>
      </div>
    </div>
  );
}
